// Utility layer (TS-2.5.04) - pure, no side effects. The admin panels' timestamp formatter,
// mirroring decks/lib/deckFormat.ts formatDateTime (and AuditPage's inline equivalent) with the
// same fallback semantics: empty in -> em dash, unparseable in -> the raw string rather than a
// throw on server data. Duplicated per feature rather than imported across features, on the
// codebase's existing precedent (no feature imports another feature's lib).
export function formatDateTime(isoDateTime: string): string {
  if (!isoDateTime) return "—";
  const parsed = new Date(isoDateTime);
  if (Number.isNaN(parsed.getTime())) return isoDateTime;
  return parsed.toLocaleString();
}
